export function loadSkinCareList(categoryId) {
  return {
    type: 'LOAD_SKIN_CARE_LIST',
    categoryId
  };
}

export function loadSkinCareListCompletion(error, data) {
  return {
    type: 'LOAD_SKIN_CARE_LIST_COMPLETION',
    error,
    data,
  };
}

export function loadSkinCareCategoryList() {
  return {
    type: 'LOAD_SKIN_CARE_CATEGORY_LIST',
  };
}

export function loadSkinCareCategoryListCompletion(error, data) {
  return {
    type: 'LOAD_SKIN_CARE_CATEGORY_LIST_COMPLETION',
    error,
    data,
  };
}

export function loadSkinCareDetail(id) {
  return {
    type: 'LOAD_SKIN_CARE_DETAIL',
    id,
  }
}

export function loadSkinCareDetailCompletion(error, data) {
  return {
    type: 'LOAD_SKIN_CARE_DETAIL_COMPLETION',
    error,
    data,
  }
}

export function loadSkinCommentList(id) {
  return {
    type: 'LOAD_SKIN_COMMENT_LIST',
    id,
  };
}

export function loadSkinCommentListCompletion(error, data) {
  return {
    type: 'LOAD_SKIN_COMMENT_LIST_COMPLETION',
    error,
    data,
  };
}

export function loadSkinCommentAllList(id, willReload) {
  return {
    type: 'LOAD_SKIN_COMMENT_ALL_LIST',
    id,
    willReload,
  };
}

export function loadSkinCommentListAllCompletion(error, data) {
  return {
    type: 'LOAD_SKIN_COMMENT_ALL_LIST_COMPLETION',
    error,
    data,
  };
}

export function addFeedback(content) {
  return {
    type: 'ADD_FEED_BACK',
    content,
  }
}

export function addFeedbackCompletion(error) {
  return {
    type: 'ADD_FEED_BACK_COMPLETION',
    error,
  }
}

export function addSkinCareComment(id, content, isHide, images) {
  return {
    type: 'ADD_SKIN_CARE_COMMENT',
    id,
    content,
    isHide,
    images,
  }
}

export function addSkinCareCommentCompletion(error) {
  return {
    type: 'ADD_SKIN_CARE_COMMENT_COMPLETION',
    error,
  }
}

export function loadSkinCareShareImg(id) {
  return {
    type: 'LOAD_SKIN_CARE_SHARE_IMG',
    id,
  }
}

export function loadSkinCareShareImgCompletion(error, data) {
  return {
    type: 'LOAD_SKIN_CARE_SHARE_IMG_COMPLETION',
    error,
    data,
  }
}

export function saveSkinCartStatus(isFromSkin) {
  return {
    type: 'SAVE_SKIN_CART_STATUS',
    isFromSkin,
  }
}

export function updateSkinCareData(data) {
  return {
    type: 'UPDATE_SKIN_CARE_DATA',
    data
  }
}
